// extracted by mini-css-extract-plugin
export default {"secondaryText":"secondaryText__RegulatoryFeatureLegend__18ShL","label":"label__RegulatoryFeatureLegend__18ShL","primaryText":"primaryText__RegulatoryFeatureLegend__18ShL"};